import React, { useEffect, useState } from "react";
import GrayCard from "components/gray-card";

import styled from "styled-components";

import DateInput from "components/inputs/date-input";
import { addDays } from "utils/dateConvert";
import Typography from "components/typography";
import { Colors } from "utils/colors";

interface IProps {
  releaseDate?: Date | null;
  setReleaseDate: (date: Date | null) => void;
}
const ProposedReleaseDate = ({ releaseDate, setReleaseDate }: IProps) => {
  const [date, setDate] = useState<Date | null>(releaseDate || new Date());

  useEffect(() => {
    setReleaseDate(date);
  }, [date]);

  return (
    <GrayCard title="Proposed Release Date">
      <DateInputItem>
        <DateInput
          label="Release Date"
          initialDate={date}
          minDate={addDays(new Date(), 7)}
          selectDate={(date) => setDate(date)}
        />
      </DateInputItem>
      <Note>
        <InfoIcon>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11 6C11 8.7614 8.7614 11 6 11C3.23857 11 1 8.7614 1 6C1 3.23857 3.23857 1 6 1C8.7614 1 11 3.23857 11 6ZM6 8.875C6.2071 8.875 6.375 8.7071 6.375 8.5V5.5C6.375 5.2929 6.2071 5.125 6 5.125C5.7929 5.125 5.625 5.2929 5.625 5.5V8.5C5.625 8.7071 5.7929 8.875 6 8.875ZM6 3.5C6.27615 3.5 6.5 3.72386 6.5 4C6.5 4.27614 6.27615 4.5 6 4.5C5.72385 4.5 5.5 4.27614 5.5 4C5.5 3.72386 5.72385 3.5 6 3.5Z"
              fill="#909090"
            />
          </svg>
        </InfoIcon>
        <Typography size="s" ml="0.4" color={Colors.grey500}>
          Setting your release date to at least 1 week into the future,
          increases your chance of getting added to a playlist{" "}
        </Typography>
      </Note>
    </GrayCard>
  );
};

export default ProposedReleaseDate;

const DateInputItem = styled.div`
  width: 24rem;
`;

const Note = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2.4rem;
`;

const InfoIcon = styled.div`
  width: 1.2rem;
  height: 1.2rem;
`;
